module.exports = __webpack_public_path__ + "img/TNTEquivalencyDetails-min.6161a100.png";